/** Styl confirm dialogu k tématu Erma */
export const ConfirmDialogStyles = {
  icon: {
    size: '1.5rem'
  },
  content: {
    gap: '1rem'
  }
};
